import type { FC } from 'react';
import { createPagePropsHandler } from '@/util/server/page-props';
import { pageNameToJSX } from '@/components/pages';
import type { PageProps } from '@/types';

export const getStaticProps = createPagePropsHandler('en', 'p1');

const Index: FC<PageProps> = (props) => {
  return pageNameToJSX(props.meta.componentName, props);
};

export default Index;
